// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z00Q","question":"styles_question__1MZPx","inputVisibleButton":"styles_inputVisibleButton__12mna","note":"styles_note__TMfUg"};